<ng-progress />
<div class="page-wrapper" appPageWrapper>
  <ush-header></ush-header>
  <div class="page-content-wrapper">
    <router-outlet></router-outlet>
  </div>

  @defer (when modalPictureNeeded$ | async) {
    <ush-modal-picture></ush-modal-picture>
  } @placeholder {
    <div></div>
  }
  @defer (when videoFullscreenNeeded$ | async) {
    <ush-video-fullscreen></ush-video-fullscreen>
  } @placeholder {
    <div></div>
  }
  @defer (when modelDialogNeeded$ | async) {
    <ush-ui-modal-dialog></ush-ui-modal-dialog>
  } @placeholder {
    <div></div>
  }

  <ush-footer id="main-footer"></ush-footer>

  @defer {
    <app-go-to-top></app-go-to-top>
  } @placeholder {
    <div></div>
  }
  <ush-cookie-consent></ush-cookie-consent>
</div>
